import { Navigate } from 'react-router-dom';
import { gettoken } from 'functions/gettabconfig';

function PrivateRoute(props){
    const logado = gettoken();
    return logado ? props.children : <Navigate to='/login' />;
}

export default PrivateRoute;